import { SuiStakeProtocol } from "../../types"
import { Transaction, TransactionArgument } from "@mysten/sui/transactions";
import { HaedalUtils } from "./haedal";
import { VoloUtils } from "./volo";
import { AftermathUtils } from "./aftermath";
import { Vaults } from "../../modules/vaults";
import { VAULTS_CONFIG } from "../../constant";
import { extractStructTagFromType, isSuiCoin } from "../utils";

export function requestStakeCoin(staking_protocol: SuiStakeProtocol, tx: Transaction, sui_coin: TransactionArgument) {
  if (staking_protocol === SuiStakeProtocol.Haedal) {
    return HaedalUtils.requestStakeCoin(tx, sui_coin)
  }

  if (staking_protocol === SuiStakeProtocol.Volo) {
    return VoloUtils.requestStakeCoin(tx, sui_coin)
  }

  if (staking_protocol === SuiStakeProtocol.Aftermath) {
    return AftermathUtils.requestStakeCoin(tx, sui_coin)
  }

  return undefined
}


/**
 * Get the exchange rate of haSUI:SUI
 */
export async function getExchangeRateForStake(
  vaults: Vaults,
  staking_protocol: SuiStakeProtocol,
  sender_address: string,
  should_request_stake: boolean,
  swap_amount?: number
): Promise<string> {
  // if (staking_protocol === SuiStakeProtocol.Haedal) {
  //   return await HaedalUtils.getExchangeRateForStake(should_request_stake, swap_amount)
  // }
  // if (staking_protocol === SuiStakeProtocol.Volo) {
  //   return await VoloUtils.getExchangeRateForStake(should_request_stake, swap_amount)
  // }
  if (staking_protocol === SuiStakeProtocol.Aftermath) {
    return await AftermathUtils.getExchangeRateForStake(vaults, sender_address, should_request_stake, swap_amount)
  }
  return '0'
}

export function findSuiStakeProtocol(coin_type_a: string, coin_type_b: string, fix_amount_a: boolean): SuiStakeProtocol {
  const { haedal, volo, aftermath } = VAULTS_CONFIG.config

  const coin_type_a_format = extractStructTagFromType(coin_type_a).full_address
  const coin_type_b_format = extractStructTagFromType(coin_type_b).full_address

  if ((isSuiCoin(coin_type_a_format) && fix_amount_a) || (isSuiCoin(coin_type_b_format) && !fix_amount_a)) {
    if (haedal) {
      const coin_type = extractStructTagFromType(haedal.config.coin_type).full_address
      if (coin_type_a_format === coin_type || coin_type_b_format === coin_type) {
        return SuiStakeProtocol.Haedal
      }
    }

    if (volo) {
      const coin_type = extractStructTagFromType(volo.config.coin_type).full_address
      if (coin_type_a_format === coin_type || coin_type_b_format === coin_type) {
        return SuiStakeProtocol.Volo
      }
    }

    if (aftermath) {
      const coin_type = extractStructTagFromType(aftermath.config.coin_type).full_address
      if (coin_type_a_format === coin_type || coin_type_b_format === coin_type) {
        return SuiStakeProtocol.Aftermath
      }
    }
  }

  return SuiStakeProtocol.Mmt
}
